import { useState } from "react";

const DraperyComponent = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className="bg-white p-6 rounded-lg shadow-lg max-w-full mx-auto my-8">
      <h2 className="text-3xl font-bold text-gray-800 mb-4">
        Why Buy Drapery and Curtains?
      </h2>
      <p className="text-lg text-gray-600 mb-4">
        Nothing beats the look of classic, custom curtains and drapery. An
        elegant – and affordable – addition to any interior, today’s popular
        window panels help define the look and frame the feel of your décor,
        from formal to contemporary to cozy, comfy casual.
      </p>

      {isExpanded && (
        <div className="mt-6">
          <p className="text-lg text-gray-600 mb-4">
            Made of durable 100% cotton, easy-care cotton/polyester and
            poly/linen blends, our versatile, designer-quality custom drapes
            give you almost unlimited design and fullness options for soft,
            voluminous folds and pleats. Hang them alone to anchor any space
            with bold patterns and trending textures in hundreds of neutral hues
            to intense, intriguing colors. Or layer them with roman, sheer,
            solar, roller, cellular, or woven wood window treatments for a
            flexible, high fashion, multi-faceted effect, and greater light and
            privacy control.
          </p>
          <p className="text-lg text-gray-600 mb-4">
            Fabric finishes range from sturdy cotton canvas, to trending
            metallic and glossy sateens, sheens and embossed satins. Easily
            enhance and customize them even more with standard and optional
            features like color coordinated tiebacks, privacy and blackout
            liners, and curtain rods and rings in a variety of finishes. With
            our available matching fabric by the yard, pull the whole room
            together by using it to create your own custom fabric accents, like
            decorative pillows or a duvet.
          </p>
          <p className="text-lg text-gray-600 mb-4">
            Custom drapery and curtains at SelectBlinds.com are sold in single
            panels in two popular styles:
          </p>
          <ul className="list-disc list-inside mb-4 text-lg text-gray-600">
            <li>
              <strong>Grommet Drapes:</strong> Give your room a bold, modern
              look with easy to hang grommet drapes. Run a decorative rod
              through sturdy metal grommets to form full, dramatic folds from
              top to bottom. Choose from grommets in an antique brass or satin
              nickel finish for the perfect accent to any color and a
              one-of-a-kind look.
            </li>
            <li>
              <strong>Pleated Drapes:</strong> Our quintessential pleated drapes
              feature popular 3” pre-pinned pinch pleats that can be easily
              attached to decorative rings and hung on a rod for an instant
              update to this timeless finish to any window treatment. Order to
              stack to the left, right, or one on each side for the look and
              functionality you need.
            </li>
          </ul>
          <p className="text-lg text-gray-600 mb-4">
            Draperies are a great alternative to vertical blinds. Whether you
            like the look of drapes softly pooled on or gently brushing the
            floor, we’ll help you get the measurements just right so they hang
            just the way you want them. Here’s how to measure drapery for each
            style.
          </p>
        </div>
      )}

      <div className="flex justify-end mt-6">
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="text-blue-500 hover:text-blue-600 font-semibold"
        >
          {isExpanded ? "Read Less" : "Read More"}
        </button>
      </div>
    </div>
  );
};

export default DraperyComponent;
